/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type AudioArrangementListStatus =
  (typeof AudioArrangementListStatus)[keyof typeof AudioArrangementListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AudioArrangementListStatus = {
  completed: "completed",
  draft: "draft",
  failed: "failed",
  rendering: "rendering",
} as const;
